import register from '../endpointRegister';
import baseApi from './baseApi';

export type ApiType = ReturnType<typeof baseApi.injectEndpoints>;

const Api = baseApi.injectEndpoints({
  endpoints: (builder) => register(builder),
  overrideExisting: true,
});

export default Api;